import { render, staticRenderFns } from "./globalFilter.vue?vue&type=template&id=489ed5d8&scoped=true&"
import script from "./globalFilter.vue?vue&type=script&lang=js&"
export * from "./globalFilter.vue?vue&type=script&lang=js&"
import style0 from "./globalFilter.vue?vue&type=style&index=0&id=489ed5d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ed5d8",
  null
  
)

component.options.__file = "globalFilter.vue"
export default component.exports